import { api } from "@/lib/axios";
import { User } from "../../types/user";

const list = (): Promise<User[]> => api.get("/users").then((r) => r.data);

export default list;
